module.exports = __webpack_public_path__ + "static/media/Z1_DIFF.a9015448.png";